import React from "react";

// components
import { ColumnDef } from "@tanstack/react-table";
import DataTable from "../../../component/element/table";
import ItemAction from "../../../component/ui/action/ItemAction";

// constants and icon
import { format_date_time } from "../../../services/convert/date";

// router and services
import { useNavigate } from "react-router-dom";
import { get_service_requests } from "../../../services/apis/requests";
import { useAppDispatch, useAppSelector } from "../../../store";
import { IRequestItem } from "../../../store/types/request";

const ServiceRequest = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const requests = useAppSelector(({ request }) => request.requests);
  const limit = useAppSelector(({ request }) => request.limit);
  const offset = useAppSelector(({ request }) => request.offset);
  const total = useAppSelector(({ request }) => request.total);
  const currentPage = Math.floor(offset / limit) + 1;
  const lastPage = Math.max(1, Math.ceil(total / limit));

  const onLoad = React.useCallback(() => {
    get_service_requests(dispatch, limit, offset);
  }, [dispatch, limit, offset]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  const columns: ColumnDef<IRequestItem>[] = [
    {
      accessorKey: "service",
      header: "Name",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <span>
            {data.service?.name || data.document?.name || "—"}
          </span>
        );
      },
    },
    {
      accessorKey: "state",
      header: "Location",
      cell: ({ row }) => {
        const { state } = row.original;
        return (
          <span className="capitalize">
            {state ? `${state.name}, ${state.country.name}` : "—"}
          </span>
        );
      },
    },
    {
      accessorKey: "type",
      header: "Request Type",
      cell: ({ getValue }) => {
        const type = getValue<string>();
        return <span className="capitalize">{type || "—"}</span>;
      },
    },
    {
      accessorKey: "request_status",
      header: () => "Status",
      cell: ({ row }) => {
        return <span>{row.original.request_status?.name || "—"}</span>;
      },
    },
    {
      accessorKey: "created_at",
      header: "Order Date",
      cell: ({ getValue }) => {
        const created_at = getValue<string>();
        return (
          <span className="capitalize">
            {created_at && format_date_time(created_at)}
          </span>
        );
      },
    },
    {
      accessorKey: "id",
      header: "Action",
      cell: ({ getValue }) => {
        const id = getValue<number>();
        return (
          <ItemAction
            show_edit={false}
            show_delete={false}
            onView={() => navigate("/request/" + id)}
            onEdit={() => null}
            onDelete={() => null}
          />
          // <FaEye
          //   size={25}
          //   color="blue"
          //   onClick={() => navigate("/request/" + id)}
          //   className="cursor-pointer"
          // />
        );
      },
    },
  ];

  return (
    <div className="w-full">
      <h2 className="font-bold text-[1.4rem] capitalize">Requests</h2>

      <div className="bg-[white] mt-4">
        <DataTable
          columns={columns}
          data={requests}
          current_page={currentPage}
          last_page={lastPage}
          onNext={(page) => get_service_requests(dispatch, limit, (page - 1) * limit)}
          onPrev={(page) => get_service_requests(dispatch, limit, (page - 1) * limit)}
        />
      </div>
    </div>
  );
};

export default ServiceRequest;
